<template>
    <div class="p-6 sms-recharge-tab">
        <div class="p-5 py-3 border-bottom-custom">
            <div class="flex mb-5">
                <p class="w-3/5">
                    <span class="text-black font-bold mr-4">Account type:</span>
                    <span class="text-sm">Prepaid</span>
                </p>
                <p class="w-2/5">
                    <span class="text-black font-bold mr-4">Default Card:</span>
                </p>
            </div>
            <div class="flex">
                <p class="w-3/5 text-sm">Remaining Credits: <br />
                    <span class="text-xl text-black font-bold d-inline-block mt-1">$299.00</span>
                </p>
                <div class="w-2/5 text-sm justify-start">
                    <div class="flex align-center">
                        <img :src="selected_card.image" class="mr-2" style="width: 40px;" v-if="selected_card.image" />
                        <span>{{ selected_card.title }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex align-center p-6 py-3 mb-base">
            <p class="w-3/5">
                <span class="text-black font-bold">Billing Address</span> 
                <span class="cursor-pointer pen-icon" @click="isEditAddress = true, edit_address_content = address_content"></span>
                <br />
                <span class="text-sm d-inline-block w-1/2 mt-2">{{ address_content && address_content != '' ? address_content : 'N/A' }}</span>
            </p>
            <div>
                <vs-button class="gradient gradient-primary shadow-md text-sm" @click="addCardPopup.isOpen = true">+ Add Card</vs-button>
            </div>
        </div>

        <vs-popup class="checkout-popup-note" title="Edit Address" :active.sync="isEditAddress">
          <div class="pt-4">
            <vs-textarea maxlength="160" v-model="edit_address_content" height="150" />
            <vs-button class="text-sm" @click="saveAddressContent">Save</vs-button>
          </div>
        </vs-popup>

        <div class="p-6 py-3 mb-base">
            <p class="text-black font-bold mb-3">Recharge</p>
            <div class="text-sm flex align-center">
                <div class="w-3/5">
                    <label class="text-black font-bold d-inline-block mb-2">Recharge Amount</label>
                    <div class="w-2/3 recharge-amount-select">
                        <v-select @input="selectItem($event, 'recharge-amount')" :value="recharge_amount" label="title" :options="rechargeAmountOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" :searchable="false" />
                    </div>
                </div>
                <div class="w-2/5">
                    <label class="text-black font-bold d-inline-block mb-2">Choose Card</label>
                    <div class="choose-card-select">
                        <v-select @input="selectItem($event, 'recharge-card')" :value="selected_card" label="title" :options="cardOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" :searchable="false">
                            <template slot="option" slot-scope="option">
                                <div class="flex align-center">
                                    <img :src="option.image" class="mr-2" style="width: 40px;" v-if="option.image" />
                                    <span>{{ option.title }}</span>
                                </div>
                            </template>
                            <template slot="selected-option" slot-scope="option" :value="option">
                                <div class="flex align-center">
                                    <img :src="option.image" class="mr-2" style="width: 40px;" v-if="option.image" />
                                    <span>{{ option.title }}</span>
                                </div>
                            </template>
                        </v-select>
                    </div>
                </div>
            </div>
        </div>

        <div class="p-6 pt-3 pb-5 mb-12">
            <p class="text-black font-bold mb-3">Auto Recharge</p>
            <p class="text-sm text-grey-custom mb-4">Enable auto recharge on your card to never run low on account credit. When your account balance is low, we will recharge with the amount specified by you.</p>
            <div class="text-sm font-bold flex align-center mb-5">
                <vs-switch v-model="auto_recharge" class="mr-4"></vs-switch> 
                <span v-if="auto_recharge">Enabled</span>
                <span v-else>Disabled</span>
            </div>
            <div class="text-sm flex align-center" :class="{'disabled-auto-recharge': !auto_recharge}">
                <div class="w-3/5">
                    <label class="text-black font-bold d-inline-block mb-2">Balance Amount</label>
                    <div class="w-2/3 recharge-amount-select">
                        <v-select @input="selectItem($event, 'auto-balance-amount')" :value="balance_amount" label="title" :options="balanceAmountOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" :searchable="false" :disabled="!auto_recharge" />
                    </div>
                </div>
                <div class="w-2/5">
                    <label class="text-black font-bold d-inline-block mb-2">Recharge Amount</label>
                    <div class="recharge-amount-select">
                        <v-select @input="selectItem($event, 'auto-recharge-amount')" :value="auto_recharge_amount" label="title" :options="autoRechargeAmountOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" :searchable="false" :disabled="!auto_recharge" />
                    </div>
                </div>
            </div>
        </div>

        <div class="p-6 mb-12 total-block">
            <div class="text-sm flex align-center justify-between mb-3">
                <p class="w-3/5">Subtotal: </p>
                <p class="w-2/5 text-right">$62.50</p>
            </div>
            <div class="text-sm flex align-center justify-between">
                <p class="w-3/5 text-primary">Promo Code: </p>
                <div class="w-2/5">
                    <div class="promo-code-input-container" 
                        :class="{'show-color': promo_code && promo_code != '', 'applied': applied_promo_code && applied_promo_code != ''}">
                        <vs-input v-model="promo_code" placeholder="Promo code" class="text-black font-bold w-full" @input="inputPromoCode"></vs-input>
                        <vs-button class="text-sm" @click="applied_promo_code = promo_code">
                            <span v-if="applied_promo_code && applied_promo_code != ''">APPLIED</span>
                            <span v-else>APPLY</span>
                        </vs-button>
                    </div>
                    <p class="text-danger text-right mt-4" v-if="applied_promo_code && applied_promo_code != ''">-$2.00</p>
                </div>
            </div>

            <vs-divider></vs-divider>
            <div class="text-black font-bold flex align-center justify-between">
                <p class="w-3/5">Total: </p>
                <p class="w-2/5 text-right">${{ applied_promo_code && applied_promo_code != '' ? '60.50' : '62.50' }}</p>
            </div>
        </div>

        <div class="flex justify-center pt-3">
            <vs-button class="text-sm">Complete order</vs-button>
        </div>

        <add-card-popup :addCardPopup="addCardPopup"></add-card-popup>
    </div>
</template>

<script>
import vSelect from 'vue-select'
export default {
    name: "sms-recharge-tab",
    components: { vSelect },
    data() {
        return {
            rechargeAmountOptions: [
                { title: '2500 SMS : $62.50 (2.5¢/SMS)' },
                { title: '5000 SMS : $100 (2.0¢/SMS)' },
                { title: '10000 SMS : $180 (1.8¢/SMS)' }
            ],
            recharge_amount: { title: '2500 SMS : $62.50 (2.5¢/SMS)' },
            cardOptions: [
                { title: 'None', image: null },
                { title: 'Visa-1 777', image: '/visa.svg' },
                { title: 'Visa-2 777', image: '/visa.svg' },
                // { title: 'Visa-3 777', image: '/visa.svg' },
            ],
            selected_card: { title: 'Visa-1 777', image: '/visa.svg' },
            auto_recharge: false,
            balanceAmountOptions: [
                { title: '500 SMS' },
                { title: '1000 SMS' },
                { title: '2000 SMS' }
            ],
            balance_amount: { title: '500 SMS' },
            autoRechargeAmountOptions: [
                { title: '2500 SMS : $62.50' },
                { title: '5000 SMS : $100.00' },
                { title: '10000 SMS : $180.00' }
            ],
            auto_recharge_amount: { title: '2500 SMS : $62.50' },
            promo_code: '',
            addCardPopup: {
                isOpen: false
            },
            isEditAddress: false,
            edit_address_content: "11011 Richmond Ave, Ste 250 Houston, TX 77042",
            address_content: "11011 Richmond Ave, Ste 250 Houston, TX 77042",
            applied_promo_code: ''
        }
    },
    methods: {
        saveAddressContent() {
            this.address_content = this.edit_address_content;
            this.isEditAddress = false;
        },
        inputPromoCode() {
            this.applied_promo_code = "";
        },
        selectItem(e, type) {
            if(type == "recharge-amount") {
                this.recharge_amount = e;
            }
            if(type == "recharge-card") {
                this.selected_card = e;
            }
            if(type == "auto-recharge-amount") {
                this.auto_recharge_amount = e;
            }
            if(type == "auto-balance-amount") {
                this.balance_amount = e;
            }
        }
    }
}
</script>